import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GridCell, OrientationEnum, RowCell } from '@urbannex/storethemes';
import { Subject, Subscription } from 'rxjs';
import { SectionEditorBridgeService } from '../../../services/section-editor-bridge.service';
import { takeUntil } from 'rxjs/operators';
import { CellEditorStoreService } from '../../cell-editor-store.service';
import { ContentWidthSliderComponent } from '../../dialogs/content-width-slider/content-width-slider.component';
import { NbPopoverDirective } from '@nebular/theme';

@Component({
  selector: 'kve-banner-cell-layout',
  templateUrl: './banner-cell-layout.component.html',
  styleUrls: ['./banner-cell-layout.component.scss']
})
export class BannerCellLayoutComponent implements OnInit {
  @Input() imageOrientation: OrientationEnum;
  @Input() bannerCellLayoutClassList: string[];
  cellLayoutThumbs$: Subscription;
  cellLayoutThumbs: any[];
  hasThumbs = false;
  selectedCell: GridCell | RowCell

  widthPop: any = ContentWidthSliderComponent;
  contentWidth: string;
  contentWidth_n: number;

  selectedHeight: any;

  private destroy$ = new Subject<void>();

  heightOptions = [
    { name: "Full Height", value: "100%" },
    { name: "Auto", value: "auto" }
  ]

  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;

  constructor(private sectionEditorBridge: SectionEditorBridgeService,
    private cellEditorStoreService: CellEditorStoreService) { }

  ngOnInit(): void {
    this.cellEditorStoreService.selectedCell$.subscribe((selectedCell: GridCell | RowCell) => {
      this.selectedCell = selectedCell;
      this.contentWidth = this.selectedCell.contentWidth ? this.selectedCell.contentWidth : "100%";
      const matches = this.contentWidth.match(/(\d+)/);
      if (matches.length > 0) {
        this.contentWidth_n = +matches[0];
      }
    })
    this.cellLayoutThumbs$ = this.sectionEditorBridge.getCellLayoutOptions().pipe(takeUntil(this.destroy$))
      .subscribe(payload => {

        this.cellLayoutThumbs = payload;
        this.hasThumbs = true;
      })

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setLayout(layoutClass: string) {
    console.log({ layoutClass: layoutClass })
    this.cellEditorStoreService.updateLayoutClass(layoutClass);
  }

  setWith(width: number) {
    console.log(width)
  }

  setCellVerticalAlign(position: string) {
    console.log(position);
    this.cellEditorStoreService.selectedCell$.subscribe(cell => {
      cell.cellVerticalAlign = position;
      console.log("cell-editor-store.service.ts - updating selected cell cellVerticalAlign: " + cell);
      this.cellEditorStoreService.updateSelectedCell(cell);
    })
  }

  setCellHorizontalAlign(position: string) {
    this.cellEditorStoreService.selectedCell$.subscribe(cell => {
      cell.cellHorizontalAlign = position;
      console.log("cell-editor-store.service.ts - updating selected cell cellHorizontalAlign: " + cell);
      this.cellEditorStoreService.updateSelectedCell(cell);
    })
  }

  onHeightChange(e) {
    console.log(e.value)
    this.cellEditorStoreService.selectedCell$.subscribe(cell => {
      cell.contentHeight = e.value;
      // console.log({class:e.class,cell:cell});
      console.log("cell-editor-store.service.ts - updating selected cell contentHeight: " + cell);
      this.cellEditorStoreService.updateSelectedCell(cell);
    })
    /* this.previewEditStoreService.selectedSection$.subscribe((section:Section) => {
      section.sectionData.cellHeight = e.value;
      this.previewEditStoreService.updateSelectedSection(section);
    })
    this.cellEditorStoreService.selectedCell$.subscribe(cell => {
      cell.heightCls = e.class;
      //console.log({class:e.class,cell:cell});
      this.cellEditorStoreService.updateSelectedCell(cell);
    })
    this.cellEditorStoreService.updateSelectorPosChange(e.value); */
  }
}

/* cellVerticalAlign?:string;
    cellHorizontalAlign?:string; */
